import axios from "@configs/axios";
import { API_BASE_URL, analyticEvent } from "../utils/constants/apiRoutes";
import intercomService from "./intercomService";
import mixpanelService from "./mixpanelService";
import { INTERCOM, MIXPANEL, ALL } from "../utils/constants/analyticEventsTypes";
import { AnalyticMetaData } from "@customTypes/services/analyticEvents";

const sendEvent = (type: string, eventName: string, metaData: AnalyticMetaData) => {
  switch (type) {
    case INTERCOM:
      intercomService.track(eventName, metaData);
      break;
    case MIXPANEL:
      mixpanelService.track(eventName, metaData);
      break;
    case ALL:
      intercomService.track(eventName, metaData);
      mixpanelService.track(eventName, metaData);
      break;
    default:
      break;
  }
};

const sendEventWithBackend = (
  type: string,
  event: string,
  userId: string,
  metadata: AnalyticMetaData
) =>
  axios.post(`${API_BASE_URL}${analyticEvent.BASE_URL}`, {
    type,
    event,
    userId,
    metadata,
  });

export default { sendEvent, sendEventWithBackend };
